import BaseAtomFamilyFactory from '../../utils/BaseAtomFamilyFactory';
import repository from '../repositories/support-questions';

const operations = {
    __name: "support-questions",
    read: async (action, key) => {
        return [await repository.read(key)];
    },
}

const supportQuestionsAtomFamily = new BaseAtomFamilyFactory(operations, { rereadOnMount: false });
export default supportQuestionsAtomFamily;
